import { string, object } from '@gogame/schemas';

export const COMMENT = 'comment';
export const commentConfirmDialogSchema = object({
  [COMMENT]: string().required('Comment is required'),
});
